import { classInstance } from '@/shared/helpers/helpers';

export class SubjectControl {
	constructor(selector, options = {}) {
		this.$container = selector;

		if (!this.$container) return;

		this.selectorChapter = options.selectorChapter || '.js-subject-control__chapter';
		this.selectorLetter = options.selectorLetter || '.js-subject-control__letter';

		this.init();
	}

	init() {
		classInstance.set(this.$container, { subjectControl: this });

		this.$chapterArr = Array.from(this.$container.querySelectorAll(this.selectorChapter));
		this.$letterArr = Array.from(this.$container.querySelectorAll(this.selectorLetter));

		this.$chapterArr.forEach((element) => {
			element.addEventListener('click', this.chapterHandler.bind(this));
		});
		this.$letterArr.forEach((element) => {
			element.addEventListener('click', this.letterHandler.bind(this));
		});
	}

	destroy() {
		classInstance.del(this.$container, 'subjectControl');
		this.$chapterArr.forEach(($element) => {
			$element.removeEventListener('click', this.chapterHandler);
		});
		this.$letterArr.forEach(($element) => {
			$element.removeEventListener('click', this.letterHandler);
		});
	}

	reinit() {
		this.destroy();
		this.init();
	}

	chapterHandler(event) {
		this.toggleChapter(event.target.closest(this.selectorChapter));
	}

	letterHandler(event) {
		this.toggleLetter(event.target.closest(this.selectorLetter));
	}

	toggleChapter($element) {
		const $active = this.$chapterArr.find(($item) => $item.classList.contains('active'));
		if ($active) $active.classList.remove('active');
  
		$element.classList.add('active');
		const letters = $element.dataset.chapter === 'all' ? [] : ($element.dataset.letters || '').split(',');
  
		this.$letterArr.forEach(($item) => {
			if ($element.dataset.chapter === 'all' || letters.includes($item.dataset.letter)) {
				$item.classList.remove('hidden');
			} else {
				$item.classList.add('hidden');
			}
		});
  
		this.dispatch('changeChapter', $element.dataset.chapter);
		this.resetLetter();
	}
  
	toggleLetter($element) {
		const $active = this.$letterArr.find(($item) => $item.classList.contains('active'));
		
		if ($active) {
			if ($element === $active) {
				$element.classList.remove('active');
				this.dispatch('changeLetter', 'all');
			} else {
				$active.classList.remove('active');
				$element.classList.add('active');
				this.dispatch('changeLetter', $element.dataset.letter);
			}
		} else {
			$element.classList.add('active');
			this.dispatch('changeLetter', $element.dataset.letter);
		}
	}
  
	resetLetter() {
		const $active = this.$letterArr.find(($item) => $item.classList.contains('active'));
		if ($active) {
			$active.classList.remove('active');
			this.dispatch('changeLetter', 'all');
		}
	}
  
	dispatch(event, value) {
		this.$container.dispatchEvent(
			new CustomEvent(event, {
				detail: {
					value: value,
				},
			}),
		);
	}
}

